/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { LexplusCreateObjektDto } from '../../models/lexplus-create-objekt-dto';
import { LexplusObjektDetailDto } from '../../models/lexplus-objekt-detail-dto';

export interface ObjekteControllerCreateV1$Params {
      body: LexplusCreateObjektDto
}

export function objekteControllerCreateV1(http: HttpClient, rootUrl: string, params: ObjekteControllerCreateV1$Params, context?: HttpContext): Observable<StrictHttpResponse<LexplusObjektDetailDto>> {
  const rb = new RequestBuilder(rootUrl, objekteControllerCreateV1.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<LexplusObjektDetailDto>;
    })
  );
}

objekteControllerCreateV1.PATH = '/v1/objekte';
